import mixpanelTracker from '../../../utils/mixpanelTracker';

const CALENDAR_BUTTONS_EVENT = 'Calendar Button Clicked';

/**
 * Track calendar button click event
 * @param {string} type - Type of button clicked (today, tomorrow, mundial, personalized)
 * @param {string} calendarButtonClicked - Previous button clicked value (optional)
 * 
 * When type is 'personalized', it only tracks if the previous click wasn't 'today', 'tomorrow', or 'mundial'.
 * This prevents double-tracking when a user first clicks a quick button and then picks a custom date.
 */
export const trackCalendarButtonClick = (type, calendarButtonClicked = '') => {
  // Only track personalized if it wasn't already tracked as today/tomorrow
  const buttonsToExclude = ['today', 'tomorrow', 'mundial', 'choose'];
  if (type === 'personalized' && buttonsToExclude.includes(calendarButtonClicked)) {
    return;
  }
  
  mixpanelTracker.trackEvent(CALENDAR_BUTTONS_EVENT, { type, calendar_variant: 'old' });
};

